import React from "react";
import logo from "../../assets/home/home.svg";

const VerticalAdsSkeleton = () => (
  <div className="w-full max-w-none h-[600px] lg:h-[768px] bg-white rounded-[16px] shadow-md overflow-hidden flex flex-col animate-pulse">
    <div className="w-full h-[400px] lg:h-[520px] bg-gray-200" />
    <div className="p-4 flex flex-col gap-2 flex-grow">
      <div className="h-4 w-3/4 bg-gray-200 rounded" />
      <div className="h-3 w-full bg-gray-200 rounded" />
      <div className="h-3 w-5/6 bg-gray-200 rounded" />
      <div className="h-4 w-1/3 bg-gray-200 rounded mt-1" />
    </div>
    <div className="flex justify-between items-center px-4 pb-4">
      <div className="h-3 w-16 bg-gray-200 rounded" />
      <div className="h-6 w-10 bg-gray-200 rounded" />
    </div>
  </div>
);

const VerticalAds = ({ adsList }) => {
  if (!adsList) {
    return <VerticalAdsSkeleton />;
  }

  const handleClick = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div
      onClick={() => handleClick(adsList.link)}
      className="w-full max-w-none h-[500px] lg:h-[760px] bg-white rounded-[16px] shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer flex flex-col"
    >
      {/* Image Section */}
      <img
        src={adsList.advertiseImage}
        alt="advertise"
        className="w-full h-full object-cover "
      />
      {/* <div className="w-full h-[400px] lg:h-[520px] overflow-hidden">
      </div> */}

      {/* Content */}
      {/* <div className="p-4 lg:p-5 flex flex-col gap-2 flex-grow">
        <p className="text-sm lg:text-base text-blue-600 font-medium line-clamp-1">
          {adsList.title}
        </p>

        <p className="text-xs lg:text-sm font-semibold text-gray-800 line-clamp-3">
          {adsList.description}
        </p>

        <span className="text-sm text-blue-600 font-medium mt-2">
          Read more →
        </span>
      </div> */}

      {/* Footer */}
      {/* <div className="flex justify-between items-center px-4 pb-4">
        <span className="text-xs text-gray-400">Sponsored</span>

        <img
          src={adsList.companyLogoImage || logo}
          alt="logo"
          className="h-6 object-contain"
        />
      </div> */}
    </div>
  );
};

export default VerticalAds;
